module.exports = __webpack_public_path__ + "img/需求发布.42470816.png";